    <form [formGroup]="form" class="container-fluid" autocomplete="off" id="homebackground" >
        <div class="animated fadeIn">

            <div class="row justify-content-md-center center-login">
                <div class="col-md-4">

                    <div class="card card-accent-success animated fadeIn">
                        <a class="card-header-a" aria-controls="collapseExample">
                            <div class="card-header-buscador">
                                <i class="fa fa-sign-in"></i> Iniciar sesión
                            </div>
                        </a>
                        <div class="card-body">
                            <div class="row">
                                <div class="form-group col-md-6">
                                    <div class="row">
                                        <div class="form-group col-md-12">
                                            <label class="col-form-label required-field" for="impIdentificadorUsuario">Identificador de Usuario (DNI)</label>
                                            <input formControlName="IdentificadorUsuario" [readonly]="visibilityIniciando" name="Descripcion" title="" class="form-control"
                                                   [ngClass]="displayFieldCss('IdentificadorUsuario')"
                                                   id="inpIdentificadorUsuario"
                                                   maxlength="9"
                                                   type="text" value="">

                                            <div class="invalid-feedback" *ngIf="isFieldInvalid('IdentificadorUsuario','required')">
                                                Identificador de Usuario es obligatorio
                                            </div>
                                            <div class="invalid-feedback" *ngIf="isFieldInvalid('IdentificadorUsuario','NIF')">
                                                Formato de NIF incorrecto
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="form-group col-md-12">
                                            <label class="col-form-label required-field" for="impIdentificadorUsuario">Password</label>
                                            <input formControlName="Password" name="Password" [readonly]="visibilityIniciando" (keyup.enter)="onLogin()" title="" class="form-control"
                                                   [ngClass]="displayFieldCss('Password')" id="inpPassword" type="password" value="">

                                            <div class="invalid-feedback" *ngIf="isFieldInvalid('Password','required')">
                                                Password es obligatorio
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div *ngIf="visibilityIniciando" class="form-group col-md-6">
                                    <div class="row justify-content-md-center">
                                        <h6 style="margin-top: 12px;">Iniciando sesión...</h6>
                                    </div>
                                    <div class="row justify-content-md-center">
                                        <p-progressSpinner></p-progressSpinner>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <div class="btn-group">
                                            <button class="btn btn-secondary" type="button" title="Login en la aplicación" (click)="onLogin()"><i class="fa fa-sign-in"></i> Aceptar</button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row" *ngIf="showCASUrlKeyValue">

                                <div class="form-group col-md-12">
                                    <label class="col-form-label">Si desea cambiar o ha olvidado su contraseña utilice este enlace:</label>
                                    <div>
                                        <a href="{{urlCAS}}" title="Iniciar sesión web CAS">
                                            <span>Iniciar sesión web CAS</span>
                                        </a>
                                    </div>
                                </div>
                            </div>

                            <!----------------------------------------- Sección para añadir la identificación con Cl@ve ----------------------------------------->
                            <ng-container *ngIf="arrobaClaveEnabled">
                                <app-login-clave></app-login-clave>
                            </ng-container>
                            
                        </div>
                    </div>
                </div>
            </div>

            <!--https://medium.com/@schneidenbach/restful-api-best-practices-and-common-pitfalls-7a83ba3763b5-->
            <!--https://stackoverflow.com/questions/46434313/angular-4-async-with-loading-and-display-when-empty-->

        </div>

    </form>
